import {endpointKeys} from '@common/api'
import {FeatureFlag} from '@common/models'
import {featureFlagsNormaliser} from '@common/normalisers'

import {useApi, useWebGet} from './helpers'

const ONE_HOUR = 1000 * 60 * 60

export const useGetFeatureFlags = () =>
  useWebGet<FeatureFlag[]>(
    [endpointKeys.featureFlags],
    useApi().featureFlagsWeb(),
    featureFlagsNormaliser,
    {
      refetchInterval: ONE_HOUR,
    },
  )
